import React from "react";
import { MdSearch } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoBagHandleSharp } from "react-icons/io5";
import { FaLocationArrow } from "react-icons/fa";

const SearchBar = ({ filters, handleInputChange }) => {
  const navigate = useNavigate();

  const handleChange = (e) => {
    handleInputChange(e);
  };

  const handleSearch = () => {
    navigate("/job-search");
  };

  return (
    <div className="w-full max-w-[1320px] mb-6 lg:flex lg:flex-row flex-col items-center  gap-4 mt-10">
      {/* Job Search Input - Left Half */}
      <div className="relative flex-1 mb-2">
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#8492a6]">
          <IoBagHandleSharp className="text-lg" />
        </div>
        <input
          type="text"
          name="searchQuery"
          placeholder="Search by job keys"
          value={filters.searchQuery}
          onChange={handleChange}
          className="w-full border border-[#0000006b] pl-12 py-3 text-md rounded-md focus:outline-none transition duration-300 placeholder:text-gray-400"
        />
      </div>

      {/* Location Input - Right Half */}
      <div className="relative flex-1 mb-2">
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[#8492a6]">
          <FaLocationArrow className="text-md" />
        </div>
        <input
          type="text"
          name="location"
          placeholder="Location"
          value={filters.location}
          onChange={handleChange}
          className="w-full border border-[#0000006b] pl-12 py-3 text-md rounded-md focus:outline-none transition duration-300 placeholder:text-gray-400"
        />
      </div>

      {/* Search Button */}
      <button
        onClick={handleSearch}
        className="flex items-center gap-2 bg-[#005eb8] text-white px-6 py-3 lg:-mt-2 rounded-md text-[16px] font-medium transition duration-300 hover:bg-blue-700"
      >
        <MdSearch className="text-lg" />
        Search
      </button>
    </div>
  );
};

export default SearchBar;
